export default __webpack_public_path__ + "static/media/industry.57185ab8.svg";